import React from "react";
import "./AthleteDetailsSummary.css";

var athlete = null;
var athleteClass = 0;
var athleteGpa = null;
var athleteJersey = null;
var athleteClubTeamName = null;

const AthleteDetailsSummary = (props) => {
  athlete = props.athlete;

  var athletePositions = athlete.primaryPosition;

  athleteClass = athlete.class;

  const athleteSat = athlete.sat;
  const athleteAct = athlete.act;
  const athleteCommitted = athlete.committed;

  if (Number.isInteger(athlete.gpa)) {
    // gpa does NOT have decimal
    athleteGpa = athlete.gpa.toFixed(1);
  } else {
    // gpa HAS decimal
    athleteGpa = athlete.gpa;
  }

  var classPosition = null;
  var athleteAcademics = "";

  if (athleteGpa > 0) {
    athleteAcademics = "GPA " + athleteGpa;
  } else {
    athleteAcademics = "GPA";
  }

  if (athleteSat > 0) {
    athleteAcademics = athleteAcademics + ", SAT " + athleteSat;
  } else {
    athleteAcademics = athleteAcademics + ", SAT";
  }

  if (athleteAct > 0) {
    athleteAcademics = athleteAcademics + ", ACT " + athleteAct;
  } else {
    athleteAcademics = athleteAcademics + ", ACT";
  }

  // display Short Stop as Shortstop

  var primaryPosition = null;
  var secondaryPosition = null;

  if (athlete.primaryPosition === "Short Stop") {
    primaryPosition = "Shortstop";
  } else {
    primaryPosition = athlete.primaryPosition;
  }

  if (athlete.secondaryPosition === "Short Stop") {
    secondaryPosition = "Shortstop";
  } else {
    secondaryPosition = athlete.secondaryPosition;
  }

  if (
    athlete.secondaryPosition !== "None" &&
    athlete.secondaryPosition !== ""
  ) {
    athletePositions = primaryPosition + ", " + secondaryPosition;
  } else {
    athletePositions = primaryPosition;
  }

  if (athlete.primaryPosition !== "None" && athlete.primaryPosition !== "") {
    if (athleteClass === "college_transfer") {
      classPosition = <>College Transfer, {athletePositions}</>;
    } else {
      classPosition = (
        <>
          Class of {athleteClass}, {athletePositions}
        </>
      );
    }
  } else if (athleteClass === "college_transfer") {
    classPosition = <>College Transfer</>;
  } else {
    classPosition = <>Class of {athleteClass}</>;
  }

  if (athlete.jersey && athlete.jersey !== "None") {
    athleteJersey = "#" + athlete.jersey;
  } else {
    athleteJersey = null;
  }

  if (
    athlete.clubTeamName &&
    athlete.clubTeamName !== "" &&
    athlete.clubTeamName !== "None"
  ) {
    athleteClubTeamName = <>{athlete.clubTeamName}</>;
  } else {
    athleteClubTeamName = null;
  }

  if (athleteCommitted) {
    return (
      <div className="inner-list-card">
        <h3>
          {athlete.firstName} {athlete.lastName} {athleteJersey}
        </h3>
        <p>{athleteClubTeamName}</p>
        <p>{classPosition}</p>
        <p>{athleteAcademics}</p>
        <p className="mb-0 success">COMMITTED</p>
      </div>
    );
  } else {
    return (
      <div className="inner-list-card not-commited">
        <h3>
          {athlete.firstName} {athlete.lastName} {athleteJersey}
        </h3>
        <p>{athleteClubTeamName}</p>
        <p>{athleteAcademics}</p>
        <p className="mb-0">{classPosition}</p>
      </div>
    );
  }
};

export default AthleteDetailsSummary;
